/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { PublicListingsMultiget } from '@gql/PublicListingsMultiget'
import { FragmentProductListingBox } from '@gql/FragmentProductListingBox'

export function getListingsFromCache(client: ReturnType<typeof useApollo>, ids: string[]): Promise<gen.ProductListingBoxFragment[]> {
  return useAbstractionFetch<gen.ProductListingBoxFragment, gen.PublicListingsMultigetQuery, gen.PublicListingsMultigetQueryVariables>({
    fetchPolicy: 'cache-first',
    client,
    fragment: FragmentProductListingBox,
    fragmentName: 'ProductListingBox',
    ids,
    query: PublicListingsMultiget,
    vars: (input) => ({ input }),
  })
}

export function useGetListings(idsFunc: () => None | string[], pricing: ProductPricingType) {
  const client = useApollo('get')

  const { items: _items, refetch } = useMultigetFecher({
    ids: () => idsFunc(),
    fetch: (ids) => getListingsFromCache(client, ids),
  })

  const privateGetter = useCatalogPrivate(() => _items.value, pricing)
  const itemsFull = computed(() => privateGetter.toBoxes(_items.value))

  client.onResetStore(() => helpers.sleep(0).then(() => refetch()))

  return {
    items: itemsFull,
    getOneById: (id: string | None) => helpers.arrFindId(itemsFull.value, id, (i) => i.id),
    createGetter() {
      const arr = itemsFull.value
      return (id: string | None) => helpers.arrFindId(arr, id, (i) => i.id)
    },
  }
}
